export default __webpack_public_path__ + "static/media/logo.d4f1cd30.svg";